import { observer } from 'mobx-react';

import { AnalyticsAttributes } from '../../../../../../../app/shared/analytics/AnalyticsAttributes';
import Icon from '../../../../../../../app/shared/components/Icon/Icon';
import SelectableRoundImage from '../../../../../../../app/shared/components/SelectableRoundImage/SelectableRoundImage';
import css from './ProductOptionVariation.css';
import ProductOptionVariationState from './ProductOptionVariationState';

interface ProductOptionVariationProps {
  selectedConfigurationCode: string;
  state: ProductOptionVariationState;
  onClick: (item: ProductOptionVariationState) => void;
}

const ProductOptionVariation = ({ selectedConfigurationCode, state, onClick }: ProductOptionVariationProps) => {
  return (
    <div
      className={css.container}
      {...AnalyticsAttributes.get({
        id: state.optionName,
        label: state.name,
        product: state.productName,
        'product-code': selectedConfigurationCode,
      })}
    >
      <SelectableRoundImage
        className={css.image}
        classNameInner={state.isNotSelectedAccessory ? css.iconContainer : undefined}
        customElement={state.isNotSelectedAccessory ? <Icon className={css.icon} name="ban" /> : undefined}
        image={state.thumbnail}
        onClick={() => onClick(state)}
        isSelected={state.isActive}
      />
      {state.name && <div className={css.name}>{state.name}</div>}
    </div>
  );
};

export default observer(ProductOptionVariation);
